import { getApiInspectionsV1CompaniesRetrieveQueryKey, type InspectionCompany, useQueryClient } from 'api';
import { useState } from 'react';
import { Box, Instruction, Typography } from 'ui';

import { CompanyInspectorsList } from '../CompanyInspectorsList/CompanyInspectorsList';
import { InspectionCompanyMutate } from '../InspectionCompanyMutate/InspectionCompanyMutate';
import { InspectorMutate } from '../InspectorMutate/InspectorMutate';

export const CompanyAndInspectorMutate = ({
  onClose,
  company,
}: {
  onClose: () => void;
  company: InspectionCompany | null;
}) => {
  const [currentCompany, setCurrentCompany] = useState<InspectionCompany | null>(company);
  const queryClient = useQueryClient();

  return (
    <Box>
      <InspectionCompanyMutate
        onClose={() => {
          setCurrentCompany(null);
          onClose();
        }}
        onSave={(company) => {
          setCurrentCompany(company);
        }}
        {...(currentCompany
          ? { action: 'edit' as const, company: currentCompany }
          : { action: 'create' as const, company: undefined })}
      />

      <Box p={2}>
        <Typography variant="h6">Inspectors</Typography>
        {currentCompany ? <CompanyInspectorsList companyId={currentCompany.id} /> : null}
      </Box>

      {currentCompany ? (
        <InspectorMutate
          company={currentCompany}
          action="create"
          onSave={() => {
            queryClient.invalidateQueries({
              queryKey: getApiInspectionsV1CompaniesRetrieveQueryKey(currentCompany.id),
            });
          }}
        />
      ) : (
        <Instruction>Create the company to assign inspectors.</Instruction>
      )}
    </Box>
  );
};
